import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "mt-2" };
const _hoisted_2 = { class: "col fw-bold mb-2" };
const _hoisted_3 = { class: "flex-fill" };
const _hoisted_4 = ["onUpdate:modelValue", "value", "onChange"];
const _hoisted_5 = { class: "form-check-label" };
const _hoisted_6 = {
    key: 0,
    class: "ms-3"
};
const _hoisted_7 = { class: "small" };
const _hoisted_8 = {
    key: 0,
    class: "mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_field_container = _resolveComponent("g-field-container");
    const _component_g_select_field = _resolveComponent("g-select-field");
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.caption), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.fields, (tField) => {
            return (_openBlock(), _createElementBlock("div", {
                key: tField.member,
                class: "d-flex flex-row"
            }, [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.element?.isRadio === true)
                        ? (_openBlock(), _createBlock(_component_g_field_container, {
                            key: 0,
                            "error-message": tField.validation?.message
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.element.options, (option) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "form-check mb-2",
                                        key: option.value
                                    }, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "radio",
                                            "onUpdate:modelValue": ($event) => ((_ctx.data[tField.member]) = $event),
                                            value: option.value,
                                            onChange: ($event) => (_ctx.onValueChanged(tField))
                                        }, null, 40, _hoisted_4), [
                                            [_vModelRadio, _ctx.data[tField.member]]
                                        ]),
                                        _createElementVNode("label", _hoisted_5, _toDisplayString(option.label), 1)
                                    ]));
                                }), 128))
                            ]),
                            _: 2
                        }, 1032, ["error-message"]))
                        : (_ctx.element.options)
                            ? (_openBlock(), _createBlock(_component_g_select_field, {
                                key: 1,
                                label: _ctx.caption,
                                "search-enabled": true,
                                "show-clear-button": _ctx.element.isOptional,
                                "show-label": false,
                                "data-member": tField.member,
                                "data-mode": "model",
                                "data-object": _ctx.data,
                                itemSource: _ctx.element.options,
                                valueExpr: "value",
                                displayExpr: "label",
                                "error-message": tField.validation?.message,
                                onValidate: ($event) => (_ctx.onValueChanged(tField))
                            }, null, 8, ["label", "show-clear-button", "data-member", "data-object", "itemSource", "error-message", "onValidate"]))
                            : _createCommentVNode("", true)
                ]),
                (_ctx.element.isMultipleOccurs && _ctx.content.fields.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_g_button, {
                            text: "Löschen",
                            onClick: ($event) => (_ctx.onMultiRemove(tField))
                        }, null, 8, ["onClick"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        }), 128)),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.element.info), 1),
        (_ctx.element.isMultipleOccurs)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_g_button, {
                    text: "+ Hinzufügen",
                    style: { "max-width": "150px" },
                    onClick: _ctx.onMultiAdd
                }, null, 8, ["onClick"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
